import React from "react";
import { Route, useHistory } from "react-router-dom";
import { SettingsContainer } from "../../state-containers/SettingsContainer";
import { useEnvironments } from "../../state-containers/EnvironmentsContainer";
import { StyledEnvironmentSwitcher, StyledEnvironmentButton, StyledEnvironmentList, } from "./EnvironmentSwitcherStyles";
import { Button } from "semantic-ui-react";
import { images } from "../../assets";
function EnvironmentSwitcher(props) {
    var history = useHistory();
    var environments = useEnvironments().environments;
    var settings = SettingsContainer.useContainer();
    var changeEnvironment = function (environmentId) {
        var _a;
        localStorage.setItem(((_a = settings.substitutionsManager) === null || _a === void 0 ? void 0 : _a.getAppId()) + "-env", environmentId);
        settings.fetchActiveUrls();
    };
    return (React.createElement(StyledEnvironmentSwitcher, null, settings.canSwitchEnvironments ? (React.createElement("div", null,
        React.createElement("h2", null, "Select Environment"),
        React.createElement(StyledEnvironmentList, null,
            React.createElement("div", null, environments.map(function (environment) {
                var _a;
                return (React.createElement(StyledEnvironmentButton, { key: environment.environment_id, onClick: function () { return changeEnvironment(environment.environment_id); } },
                    React.createElement("div", null, environment.environment_id + ": " + environment.environment_name),
                    ((_a = settings.substitutionsManager) === null || _a === void 0 ? void 0 : _a.getEnvironment(settings.canSwitchEnvironments)) === environment.environment_id ? (React.createElement("img", { src: images.icnTickLarge, alt: "selected" })) : null));
            }))),
        React.createElement(Button, { content: "Go home", onClick: function () { return history.push(props.homePath); } }))) : null));
}
// The react router only pick up components that have a path prop but because we want to have
// a default value for our path this won't work as a component.
// Instead we return an array of the routes.
export function RouteEnvironmentSwitcher(homePath, routePath) {
    if (homePath === void 0) { homePath = "/"; }
    return [
        React.createElement(Route, { key: "envs", path: routePath !== null && routePath !== void 0 ? routePath : "/NN4M" + process.env.REACT_APP_RCODE + "-ENVIRONMENTS" },
            React.createElement(EnvironmentSwitcher, { homePath: homePath })),
    ];
}
